import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { setAuthToken } from '../services/auth'
import API_URL from '../config'

function UserProfile() {
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { username } = useParams()

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        setLoading(true)
        setAuthToken(localStorage.getItem('token'))
        const response = await axios.get(`${API_URL}profile/${username}/`)
        setProfile(response.data)
      } catch (error) {
        console.error('Error fetching user profile:', error)
        setError(error.response?.data?.error || 'An error occurred while fetching the profile')
      } finally {
        setLoading(false)
      }
    }

    if (username) {
      fetchUserProfile()
    }
  }, [username])

  if (loading) return <div className='p-5'>Loading profile...</div>

  if (error)
    return (
      <div className='p-5'>
        <div className='text-red-500'>{error}</div>
      </div>
    )

  if (!profile) return <div className='p-5'>Profile not found</div>

  return (
    <div className='container p-5'>
      <div className='flex flex-col items-center'>
        {profile.spiral_image && (
          <div className='mb-4'>
            <img
              src={profile.spiral_image}
              alt={`${profile.username}'s profile`}
              className='h-32 w-32 rounded-full'
              onError={(e) => {
                console.error('Image failed to load')
                e.target.src = '/default-avatar.png' // Fallback to default if available
              }}
            />
          </div>
        )}

        <h1 className='mb-2 text-2xl font-bold'>{profile.username}</h1>

        {/* Only show email if it was returned (for own profile or staff) */}
        {profile.email && <div className='text-gray-500 mb-2'>{profile.email}</div>}

        {/* Content about this user could be added here - 
            like their collection stats, recent activity, etc. */}
      </div>
    </div>
  )
}

export default UserProfile
